import React, { useEffect, useState } from "react";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import AboutPageImg from "./../assets/AboutPage.webp";
import {
  FaSchool,
  FaBook,
  FaUsers,
  FaCoffee,
  FaGlobe,
  FaHospital,
  FaMicrophone,
  FaLeaf,
  FaUtensils,
  FaBuilding,
} from "react-icons/fa";
import { Helmet } from "react-helmet-async";

const About = () => {
  const [showMore, setShowMore] = useState(false);
  const [showMore1, setShowMore1] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>About ISKCON Vijayawada – Our Purpose, People & Devotion</title>
        <meta
          name="description"
          content="Learn about ISKCON Vijayawada's vision, leadership, and how we promote Krishna consciousness through seva, devotion, and community spiritual programs."
        />
        <meta
          name="keywords"
          content="About ISKCON Vijayawada, Krishna temple vision, ISKCON Andhra Pradesh, spiritual mission"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.iskconvijayawada.org/about" />
      </Helmet>

      <Header />

      <div className="w-full">
        {/* Main Banner */}
        <div className="flex flex-col items-center py-8 px-4 md:py-12">
          <div className="text-center max-w-5xl">
            <span className="text-sm md:text-base text-gray-600 uppercase tracking-wider">
              ABOUT ISKCON
            </span>
            <h1 className="text-2xl md:text-4xl font-bold text-[#C61D21] mt-2 mb-3">
              About ISKCON Vijayawada – Our Purpose and Vision
            </h1>
            <h2 className="text-lg md:text-2xl text-gray-600 mb-6">
              Learn About Our Devotees, Values, and Global Krishna Mission
            </h2>
            <h2 className="text-xl md:text-3xl font-semibold text-[#C61D21] mt-8 mb-6">
              The International Society for Krishna Consciousness
            </h2>

            <div className="text-left text-gray-700 space-y-4">
              <p className="text-base md:text-lg leading-relaxed">
                International Society for Krishna Consciousness, also popularly
                known as the Hare Krishna movement is a spiritual society
                founded by His Divine Grace A.C. Bhaktivedanta Swami Prabhupada
                in July 1966 in New York. ISKCON belongs to the
                Gaudiya-Vaishnava sampradaya, a monotheistic tradition within
                Vedic culture. Today ISKCON comprises of more than 400 temples,
                40 rural communities and over 100 vegetarian restaurants. It
                also conducts special projects throughout the world, such as
                "Food for Life", the only free vegetarian relief program in the
                world.
              </p>

              {showMore && (
                <>
                  <p className="text-base md:text-lg leading-relaxed">
                    The aim of ISKCON is to acquaint all people of world with
                    universal principles of self-realization and God
                    consciousness so that they may derive the highest benefit of
                    spiritual understanding, unity and peace. The Vedic
                    literature recommend that in the present age of Kali-yuga
                    the most effective means of achieving self-realization is
                    always hear about, glorify, and remember the all-attractive
                    Supreme Lord Sri Krishna. Therefore, it recommends the
                    chanting of the Holy Names: Hare Krishna Hare Krishna
                    Krishna Krishna Hare Hare / Hare Rama Hare Rama Rama Rama
                    Hare Hare. This sublime chanting puts the chanter directly
                    in touch with the Supreme Lord through the sound vibration
                    of His Holy Name.
                  </p>
                  <p className="text-base md:text-lg leading-relaxed">
                    ISKCON follows the teachings of the Vedas and Vedic
                    scriptures, including the Bhagavad-gita and Srimad
                    Bhagavatam which teach Vaishnavism or devotion to God
                    (Krishna) in His Supreme Personal aspect of Sri Sri Radha
                    Krishna.
                  </p>
                  <p className="text-base md:text-lg leading-relaxed">
                    These teachings are received through the preceptorial line
                    known as the Brahma-Madhav-Gaudiya Vaishnava sampradaya.
                    ISKCON is part of the disciplic succession which started
                    with Lord Krishna Himself and continued with Srila
                    Vyasadeva, Srila Madhavacharya, Sri Caitanya Mahaprabhu and
                    in the present day His Divine Grace A. C. Bhaktivedanta
                    Swami Prabhupada and his followers.
                  </p>
                  <p className="text-base md:text-lg leading-relaxed">
                    ISKCON's teachings are non-sectarian, following the
                    principle of sanatana dharma or eternal religion, which
                    denotes the eternal activity of all living beings – loving
                    devotional service (bhakti-yoga) to Supreme Personality of
                    Godhead.
                  </p>
                </>
              )}

              <button
                onClick={() => setShowMore(!showMore)}
                className="text-[#C61D21] font-semibold hover:underline"
              >
                {showMore ? "SHOW LESS <<" : "READ MORE >>"}
              </button>
            </div>
          </div>
        </div>

        {/* Image Section */}
        <div className="flex justify-center px-4 py-8 md:py-12">
          <img
            loading="lazy"
            src={AboutPageImg}
            alt="ISKCON origin & story"
            className="rounded-xl w-full max-w-6xl h-auto md:h-[600px] object-cover"
          />
        </div>

        {/* History Banner */}
        <div className="flex flex-col items-center py-8 px-4 md:py-12 bg-gray-50">
          <div className="text-center max-w-5xl">
            <h2 className="text-xl md:text-3xl font-semibold text-[#C61D21] mb-6">
              History of the Hare Krishna Movement
            </h2>

            <div className="text-left text-gray-700 space-y-4">
              <p className="text-base md:text-lg leading-relaxed">
                In 1965, at the age of 69,{" "}
                <strong>A. C. Bhaktivedanta Swami Prabhupada</strong> boarded
                the steamship 'Jaladuta' from on his way to United States. At an
                age when most people think of retiring Srila Prabhupada
                undertook this arduous journey to fulfill the mission of Lord
                Caitanya and follow the instruction of his spiritual master
                Bhaktisiddhanta Saraswati Thakur to carry the message of
                Bhagavad-gita and Srimad Bhagavatam to Western world.
              </p>

              {showMore1 && (
                <>
                  <p className="text-base md:text-lg leading-relaxed">
                    After arriving in New York City in September 1965, Srila
                    Prabhupada struggled alone for the first year to establish
                    his Krishna conscious movement. He lived simply, lectured
                    whenever and wherever he got the opportunity and gradually
                    began to attract some small interest in his teaching. In
                    July of 1966, while still working from an obscure storefront
                    on New York City's Lower East Side, Srila Prabhupada
                    nonetheless founded a spiritual society intended for
                    worldwide participation. He called it International Society
                    for Krishna Consciousness or ISKCON for short and thus began
                    the Hare Krishna movement in America.
                  </p>
                  <p className="text-base md:text-lg leading-relaxed">
                    At the time of incorporation, Srila Prabhupada had not
                    attracted even one committed follower. Undeterred, he
                    enlisted volunteers from among the small group of regular
                    attendees at his evening lectures to act as ISKCON's first
                    trustees. That was then. Today, ISKCON comprises of more
                    than 400 temples worldwide, 40 rural communities and over
                    100 vegetarian restaurants. It also conducts special
                    projects throughout the world, such as "Food for Life", the
                    only free vegetarian relief program in the world.
                  </p>
                </>
              )}

              <button
                onClick={() => setShowMore1(!showMore1)}
                className="text-[#C61D21] font-semibold hover:underline"
              >
                {showMore1 ? "SHOW LESS <<" : "READ MORE >>"}
              </button>
            </div>
          </div>
        </div>

        {/* Accomplishments List */}
        <div className="py-12 px-4 md:px-12">
          <div className="max-w-7xl mx-auto">
            <h1 className="text-[#C61D21] text-3xl md:text-5xl font-bold text-center mb-12">
              ISKCON's Accomplishments Over Past 50 Years
            </h1>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-[#C61D21] rounded-[30px] md:rounded-[100px] p-6 md:p-12 flex items-center gap-4 text-white">
                <p className="text-base md:text-lg">
                  750-The Number Of ISKCON Centers, Temples And Schools
                  Worldwide.
                </p>
                <FaSchool className="w-12 h-12 md:w-16 md:h-16 flex-shrink-0" />
              </div>

              <div className="bg-[#C61D21] rounded-[30px] md:rounded-[100px] p-6 md:p-12 flex items-center gap-4 text-white">
                <p className="text-base md:text-lg">
                  550 Million The Number Of Books Published And Distributed By
                  ISKCON Worldwide.
                </p>
                <FaBook className="w-12 h-12 md:w-16 md:h-16 flex-shrink-0 md:-order-1" />
              </div>

              <div className="bg-[#C61D21] rounded-[30px] md:rounded-[100px] p-6 md:p-12 flex items-center gap-4 text-white">
                <p className="text-base md:text-lg">
                  15 Million The Number Of People Who Worship In ISKCON Temples
                  Around The World, Every Year.
                </p>
                <FaUsers className="w-12 h-12 md:w-16 md:h-16 flex-shrink-0" />
              </div>

              <div className="bg-[#C61D21] rounded-[30px] md:rounded-[100px] p-6 md:p-12 flex items-center gap-4 text-white">
                <p className="text-base md:text-lg">
                  15 Million The Number Of People Who Worship In ISKCON Temples
                  Around The World, Every Year.
                </p>
                <FaUsers className="w-12 h-12 md:w-16 md:h-16 flex-shrink-0 md:-order-1" />
              </div>

              <div className="bg-[#C61D21] rounded-[30px] md:rounded-[100px] p-6 md:p-12 flex items-center gap-4 text-white">
                <p className="text-base md:text-lg">
                  1.3 Million The Number Of Meals Distributed Every Day To Needy
                  School Children In India By ISKCON Food Relief Foundation,
                  Also Known As 'Annamrita' As Part Of The Governement's Mid-Day
                  Meal Programme.
                </p>
                <FaCoffee className="w-12 h-12 md:w-16 md:h-16 flex-shrink-0" />
              </div>

              <div className="bg-[#C61D21] rounded-[30px] md:rounded-[100px] p-6 md:p-12 flex items-center gap-4 text-white">
                <p className="text-base md:text-lg">
                  260000-Devotees Walked 260000 Kms Visiting 52,000 Towns And
                  Villages In 170 Countries As Part Of The Worldwide Padayatra
                  To Bring The Holy Name To Every Town And Village Around The
                  World.
                </p>
                <FaGlobe className="w-12 h-12 md:w-16 md:h-16 flex-shrink-0 md:-order-1" />
              </div>

              <div className="bg-[#C61D21] rounded-[30px] md:rounded-[100px] p-6 md:p-12 flex items-center gap-4 text-white">
                <p className="text-base md:text-lg">
                  3,40,000-The Number Of Patients Treated By ISKCON Hospitals,
                  Mobile Clinics And Eye Camps.
                </p>
                <FaHospital className="w-12 h-12 md:w-16 md:h-16 flex-shrink-0" />
              </div>

              <div className="bg-[#C61D21] rounded-[30px] md:rounded-[100px] p-6 md:p-12 flex items-center gap-4 text-white">
                <p className="text-base md:text-lg">
                  100,000-Initiated Disciples. In Bengal Alone &gt;1 Cr Chanting
                </p>
                <FaMicrophone className="w-12 h-12 md:w-16 md:h-16 flex-shrink-0 md:-order-1" />
              </div>

              <div className="bg-[#C61D21] rounded-[30px] md:rounded-[100px] p-6 md:p-12 flex items-center gap-4 text-white">
                <p className="text-base md:text-lg">
                  6000-There Are More Than 6000 Hare Krishna Festivals Held
                  Every Year Around The World.
                </p>
                <FaUsers className="w-12 h-12 md:w-16 md:h-16 flex-shrink-0" />
              </div>

              <div className="bg-[#C61D21] rounded-[30px] md:rounded-[100px] p-6 md:p-12 flex items-center gap-4 text-white">
                <p className="text-base md:text-lg">
                  65 The Number Of Eco-Friendly Farms Run By ISKCON To Practice
                  'simple Living And High Thinking'.
                </p>
                <FaLeaf className="w-12 h-12 md:w-16 md:h-16 flex-shrink-0 md:-order-1" />
              </div>

              <div className="bg-[#C61D21] rounded-[30px] md:rounded-[100px] p-6 md:p-12 flex items-center gap-4 text-white">
                <p className="text-base md:text-lg">
                  110-The Number Of Hare Krishna Restaurants Around The World.
                </p>
                <FaUtensils className="w-12 h-12 md:w-16 md:h-16 flex-shrink-0" />
              </div>

              <div className="bg-[#C61D21] rounded-[30px] md:rounded-[100px] p-6 md:p-12 flex items-center gap-4 text-white">
                <p className="text-base md:text-lg">
                  350-Rath Yatra Across The Globe Per Year
                </p>
                <FaBuilding className="w-12 h-12 md:w-16 md:h-16 flex-shrink-0 md:-order-1" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default About;
